import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Mail, Heart, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';

const t = {
  fr: {
    navTitle: 'Navigation',
    home: 'Accueil',
    menu: 'Menu',
    contact: 'Contact',
    legalTitle: 'Légal',
    legal: 'Mentions légales',
    terms: 'Conditions générales',
    privacy: 'Politique de confidentialité',
    payment: 'Modalités de paiement',
    tagline: 'Social Media & Content Studio',
    seoDesc: 'Cocoonut Digital accompagne les restaurants et lieux de vie à Strasbourg dans la gestion de leurs réseaux sociaux et la création de contenu visuel pour attirer plus de clients.',
    rights: 'Tous droits réservés.',
    madeWith: 'Créé avec',
    madeIn: 'à Strasbourg',
  },
  en: {
    navTitle: 'Navigation',
    home: 'Home',
    menu: 'Menu',
    contact: 'Contact',
    legalTitle: 'Legal',
    legal: 'Legal notice',
    terms: 'Terms & conditions',
    privacy: 'Privacy policy',
    payment: 'Payment terms',
    tagline: 'Social Media & Content Studio',
    seoDesc: 'Cocoonut Digital supports restaurants and hospitality venues in Strasbourg with social media management and visual content creation to attract more clients.',
    rights: 'All rights reserved.',
    madeWith: 'Made with',
    madeIn: 'in Strasbourg',
  },
};

const Footer = () => {
  const { lang } = useLang();
  const tx = t[lang];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#151515] text-white py-16 md:py-20">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div className="space-y-4">
              <h4 className="text-sm uppercase tracking-widest text-[#717171] font-mono mb-4">{tx.navTitle}</h4>
              <ul className="space-y-3 text-white/60">
                <li><Link to="/" className="hover:text-[#d4a574] transition-colors">{tx.home}</Link></li>
                <li><Link to="/menu" className="hover:text-[#d4a574] transition-colors">{tx.menu}</Link></li>
                <li><Link to="/contact" className="hover:text-[#d4a574] transition-colors">{tx.contact}</Link></li>
              </ul>
            </div>

            <div className="space-y-4">
              <h4 className="text-sm uppercase tracking-widest text-[#717171] font-mono mb-4">{tx.legalTitle}</h4>
              <ul className="space-y-3 text-white/60">
                <li><Link to="/mentions-legales" className="hover:text-[#d4a574] transition-colors">{tx.legal}</Link></li>
                <li><Link to="/conditions-generales" className="hover:text-[#d4a574] transition-colors">{tx.terms}</Link></li>
                <li><Link to="/politique-de-confidentialite" className="hover:text-[#d4a574] transition-colors">{tx.privacy}</Link></li>
                <li><Link to="/modalites-de-paiement" className="hover:text-[#d4a574] transition-colors">{tx.payment}</Link></li>
              </ul>
            </div>

            <div className="space-y-5">
              <div>
                <h3 className="text-xl md:text-2xl font-brand-display text-[#d4a574] mb-2">Cocoonut Digital</h3>
                <p className="text-xs uppercase tracking-widest text-white/40 font-mono">{tx.tagline}</p>
              </div>
              <p className="text-white/60 text-sm leading-relaxed">{tx.seoDesc}</p>
              <div className="space-y-3 pt-2">
                <a href="mailto:rhamgffry@cocoonutconcept.com" className="flex items-center gap-3 text-white/60 hover:text-[#d4a574] transition-colors text-sm">
                  <Mail size={16} className="text-[#d4a574]" />rhamgffry@cocoonutconcept.com
                </a>
                <a href="https://www.instagram.com/cocoonut_digital" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/60 hover:text-[#d4a574] transition-colors text-sm">
                  <Instagram size={16} className="text-[#d4a574]" />@cocoonut_digital
                </a>
                <div className="flex items-center gap-3 text-white/60 text-sm">
                  <MapPin size={16} className="text-[#d4a574]" />Strasbourg, France
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50">
              <p>© {currentYear} Cocoonut Digital. {tx.rights}</p>
              <p className="flex items-center gap-2">{tx.madeWith} <Heart size={16} className="text-[#d4a574] fill-[#d4a574]" /> {tx.madeIn}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#4a5d6c]/5 rounded-full blur-3xl pointer-events-none" />
    </footer>
  );
};

export default Footer;
